// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2UzHj","content":"ManualTimeModal_content__Ysc35"};